import { fCurrency } from 'src/utils/formatNumber';

export const removeInvalidDecimalPlace = (str) => {
  if (str.match(/\./g).length > 1 && str[str.length - 1] === '.') {
    return str.slice(0, -1);
  }
  return str;
};

export const normalizeNumber = (value) => {
  // return nothing if no value
  if (!value) {
    return value;
  }

  if (value.endsWith('..')) {
    return value.slice(0, value.length - 1);
  }
  if (value.endsWith('.')) {
    return removeInvalidDecimalPlace(value);
  }

  if (value === '-') {
    return '-';
  }

  const isNegative = value.startsWith('-');
  const [amount, initialCents] = value.split('.');
  let cents = initialCents;

  if (cents) {
    cents = cents.replaceAll(/[^\d]/g, '');

    if (cents.length > 6) {
      cents = cents.slice(0, 6);
    }
  }

  const currentValue = Number(amount.replace(/[^\d]/g, ''));

  if (Number.isInteger(currentValue)) {
    const formattedValue = `${fCurrency(currentValue, false)}${
      cents ? `.${cents}` : ''
    }`;

    if (formattedValue === 'NaN') {
      return null;
    }

    return isNegative ? `-${formattedValue}` : formattedValue;
  }

  return '';
};

export const handleNumericKeyDown = (event) => {
  const allowedChars = /[0-9.-]/;
  const allowedKeys = [
    'Backspace',
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
    'Delete',
    'Tab',
    'Enter',
    'Escape',
    'Home',
    'End',
  ];
  if (!allowedChars.test(event.key) && !allowedKeys.includes(event.key)) {
    event.preventDefault();
  }
};
